import React from "react";
import { Document, Page, View, Text, Image, StyleSheet } from "@react-pdf/renderer";

const BRAND = "#9f0059";
const DARK  = "#1a1a1a";
const GREY  = "#555555";

const styles = StyleSheet.create({
  page: { fontFamily: "Helvetica", fontSize: 9, color: DARK, paddingBottom: 44 },
  headerBand: {
    backgroundColor: "#d0ced0", padding: "10 28", flexDirection: "row",
    alignItems: "center", justifyContent: "space-between",
  },
  headerLogo: { width: 70, height: 50, objectFit: "contain" },
  headerCenter: { flex: 1, alignItems: "center" },
  headerTitle: { color: DARK, fontSize: 15, fontFamily: "Helvetica-Bold", letterSpacing: 1 },
  headerSub: { color: GREY, fontSize: 8.5, marginTop: 3 },
  headerSpacer: { width: 70 },

  body: { paddingHorizontal: 28, paddingTop: 18 },

  tableHeader: { flexDirection: "row", backgroundColor: "#2d2d2d", padding: "6 8" },
  tableHeaderText: {
    color: "#fff", fontSize: 8, fontFamily: "Helvetica-Bold",
    textTransform: "uppercase", letterSpacing: 0.4,
  },
  tableRow: (even) => ({
    flexDirection: "row", backgroundColor: even ? "#fafafa" : "#ffffff",
    paddingVertical: 5, paddingHorizontal: 8, borderBottom: "1 solid #ede8ed",
  }),
  cell: { fontSize: 8.5, color: DARK },

  emptyBox: {
    marginTop: 30, padding: "20 24", backgroundColor: "#f0fdf4",
    borderRadius: 6, borderLeft: `3 solid #22c55e`, alignItems: "center",
  },
  emptyText: { fontSize: 11, color: "#166534", fontFamily: "Helvetica-Bold" },

  footer: {
    position: "absolute", bottom: 16, left: 28, right: 28, flexDirection: "row",
    justifyContent: "space-between", alignItems: "center",
    borderTop: "1 solid #ede8ed", paddingTop: 6,
  },
  footerText: { fontSize: 8, color: "#aaa" },
});

// columnas: [{ label, flex, align }] · filas: [[str, str, ...]]
const ReportePDF = ({ titulo, subtitulo, columnas = [], filas = [], logoUrl }) => (
  <Document>
    <Page size="A4" style={styles.page}>
      {/* Header */}
      <View style={styles.headerBand} fixed>
        {logoUrl ? <Image src={logoUrl} style={styles.headerLogo} /> : <View style={styles.headerSpacer} />}
        <View style={styles.headerCenter}>
          <Text style={styles.headerTitle}>{titulo}</Text>
          {subtitulo ? <Text style={styles.headerSub}>{subtitulo}</Text> : null}
        </View>
        <View style={styles.headerSpacer} />
      </View>

      {/* Cuerpo */}
      <View style={styles.body}>
        {filas.length === 0 ? (
          <View style={styles.emptyBox}>
            <Text style={styles.emptyText}>✓ Sin novedades</Text>
          </View>
        ) : (
          <View>
            {/* Header de tabla */}
            <View style={styles.tableHeader} fixed>
              {columnas.map((c, i) => (
                <Text key={i} style={[styles.tableHeaderText, { flex: c.flex || 1, textAlign: c.align || "left" }]}>
                  {c.label}
                </Text>
              ))}
            </View>
            {/* Filas */}
            {filas.map((fila, idx) => (
              <View key={idx} style={styles.tableRow(idx % 2 === 0)}>
                {fila.map((cel, j) => (
                  <Text key={j} style={[styles.cell, { flex: columnas[j]?.flex || 1, textAlign: columnas[j]?.align || "left" }]}>
                    {cel}
                  </Text>
                ))}
              </View>
            ))}
          </View>
        )}
      </View>

      {/* Footer */}
      <View style={styles.footer} fixed>
        <Text style={styles.footerText}>Twinpack — {titulo}</Text>
        <Text style={styles.footerText} render={({ pageNumber, totalPages }) => `Página ${pageNumber} de ${totalPages}`} />
      </View>
    </Page>
  </Document>
);

export default ReportePDF;
